var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgDoneUjikomIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43 13.44L19.77 2.1 24 6.33 8.43 21.9 0 13.47l4.23-4.23 4.2 4.2zm12.74-7.11l-1.4-1.4L8.43 16.27l-4.2-4.2-1.4 1.4 5.6 5.6L21.17 6.33z",
    fill: "#4CA375"
  })));
}

export default SvgDoneUjikomIcon;